import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { PlanActivoGuarderia } from "../../../services/analisisOperaciones";
import Pagination from "../../organisms/Pagination";
import { formatearFechaStr } from "../../../utils/dateUtils";
import { currencyFormat } from "../../../utils/numberUtils";
import { generatePage } from "../../../utils/tableUtils";

interface PlanesActivosTableProps {
  planesActivos: PlanActivoGuarderia[];
  isLoading: boolean;
  itemsPorPagina: number;
}

function PlanesActivosTable({
  planesActivos,
  isLoading,
  itemsPorPagina,
}: PlanesActivosTableProps) {
  const navigate = useNavigate();
  const [activePageNumber, setActivePageNumber] = useState(1);

  const paginaActual = useMemo(
    () =>
      generatePage(
        planesActivos,
        activePageNumber,
        itemsPorPagina
      ) as PlanActivoGuarderia[],
    [planesActivos, activePageNumber, itemsPorPagina]
  );

  return (
    <>
      <Table responsive hover>
        <thead>
          <tr>
            <StyledColHeader>Fecha Agendamiento</StyledColHeader>
            <StyledColHeader>Mascota</StyledColHeader>
            <StyledColHeader>Propietario</StyledColHeader>
            <StyledColHeader>Fecha Inicio</StyledColHeader>
            <StyledColHeader>Fecha Fin</StyledColHeader>
            <StyledColHeader>Días programados</StyledColHeader>
            <StyledColHeader>Días pendientes</StyledColHeader>
            <StyledColHeader>V. Total</StyledColHeader>
            <StyledColHeader>V. Pendiente</StyledColHeader>
          </tr>
        </thead>
        <tbody>
          {paginaActual.map((item) => (
            <StyledRow
              key={item.idAgendamiento}
              onClick={() => navigate(`/reservas/guarderia/${item.idAgendamiento}`)}
            >
              <td>{formatearFechaStr(item.fechaAgendamiento)}</td>
              <td>{item.mascota}</td>
              <td>{item.propietario}</td>
              <td>{formatearFechaStr(item.fechaInicio)}</td>
              <td>{formatearFechaStr(item.fechaFin)}</td>
              <td>{item.numeroDias}</td>
              <td>{item.numeroDiasPendientes}</td>
              <td>{currencyFormat(item.valorTotal)}</td>
              <td>{currencyFormat(item.valorPendiente)}</td>
            </StyledRow>
          ))}
          {!isLoading && paginaActual.length === 0 && (
            <tr>
              <td colSpan={9}>
                No hay planes activos para la fecha actual.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination
        pageSize={itemsPorPagina}
        setActivePageNumber={setActivePageNumber}
        activePageNumber={activePageNumber}
        rows={planesActivos}
      />
    </>
  );
}

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.light};
  }
`;

export default PlanesActivosTable;
